export type AnalyticsEventParamsValue = string | number | boolean | Record<string, unknown> | Array<unknown>;
export type AnalyticsEventParams = Record<string, AnalyticsEventParamsValue>;

/**
 * Represents a base class for defining analytics events within an application.
 * This class is designed to be extended for creating specific analytics event types.
 *
 * @abstract
 */
export abstract class AnalyticsEvent {
    protected constructor(
        public readonly name: string,
        public readonly params?: AnalyticsEventParams
    ) {}
}
